// extracted by mini-css-extract-plugin
export default {"root":"WrongPathErrorView__root___A453G","desktop":"WrongPathErrorView__desktop___ppoPz","mobile":"WrongPathErrorView__mobile___y7Q2h","title":"WrongPathErrorView__title___sw4YK"};